<div class="position-header">
  <div class="position">
    <app-icon
      *ngIf="isInModeration"
      [tooltipText]="'label.IsInModeration' | translate"
      [iconButtonType]="iconButtonType.moderation"
      class="mod-icon mod-icon--mobile mod-icon--desktop"
    ></app-icon>
    <span>{{ workExperience.positionTitle }}</span>
  </div>
  <div class="work-dates">
    <span
      >{{
        workExperience.dateFromMonth == null
          ? workExperience.dateFromYear
          : (workExperience.experienceDateFrom
            | date: 'y MMMM':null:currentLang)
      }}
      -
    </span>
    <span *ngIf="!workExperience.isCurrent">{{
      workExperience.dateToMonth == null
        ? workExperience.dateToYear
        : (workExperience.experienceDateTo
          | date: 'y MMMM':null:currentLang)
    }}</span>
    <span *ngIf="workExperience.isCurrent">{{
      'label.Present' | translate
    }}</span>
  </div>
</div>

<div class="work-experience">
  <div class="work-experience__left">
    <div class="location">
      <hrra-jobseeker-location
        [locations]="workExperience.extendedLocations"
      ></hrra-jobseeker-location>
    </div>
    <div class="employer">{{ workExperience.employer }}</div>
    <div
      class="description"
      [ngClass]="{
        'info__description--filled': workExperience.description != null
      }"
    >
      {{ workExperience.description }}
    </div>
    <div class="experience-types">
      <div
        class="experience-types__seniority-level"
        *ngIf="workExperience.seniorityLevelName"
      >
        <svg-icon
          src="/assets/icons/seniority-level-icon.svg"
          class="arrow-icon"
        ></svg-icon>
        <span class="experience-types__label"
          >{{ 'label.SeniorityLevel' | translate }}:
        </span>
        <span class="experience-types__value">{{
          workExperience.seniorityLevelName
        }}</span>
      </div>

      <div
        class="experience-types__employment-type"
        *ngIf="workExperience.employmentFormName"
      >
        <svg-icon
          src="/assets/icons/employment-type-icon.svg"
          class="arrow-icon"
        ></svg-icon>
        <span class="experience-types__label"
          >{{ 'label.EmploymentType' | translate }}:
        </span>
        <span class="experience-types__value">{{
          workExperience.employmentFormName
        }}</span>
      </div>

      <div class="experience-types__work-schedule" *ngIf="workExperience.workScheduleName">
        <svg-icon
          src="/assets/icons/work-schedule-icon.svg"
          class="arrow-icon"
        ></svg-icon>
        <span class="experience-types__label"
          >{{ 'label.Rate' | translate }}:
        </span>
        <span class="experience-types__value">{{workExperience.workScheduleName}}</span>
      </div>

      <div
        class="experience-types__employment-form"
        *ngIf="workExperience.employmentFormTypeName"
      >
        <svg-icon
          src="/assets/icons/employment-location-icon.svg"
          class="arrow-icon"
        ></svg-icon>
        <span class="experience-types__label"
          >{{ 'label.EmploymentLocation' | translate }}:
        </span>
        <span class="experience-types__value">{{
          workExperience.employmentFormTypeName
        }}</span>
      </div>
    </div>

    <div class="specializations">
      <div
        class="work-experience-details-specializations"
        *ngIf="workExperience.groupedSpecializations?.length"
      >
        <span class="specialization-label"
          >{{ 'label.SpecializationPosition' | translate }}:
        </span>
        <span
          class="specializations-main-container"
          *ngFor="
            let specialization of workExperience.groupedSpecializations;
            let lastContainer = last
          "
        >
          <span class="specializations-main">{{ specialization.head }}</span>
          <svg-icon
            class="categories__icon"
            src="/assets/icons/chevron-right-blue.svg"
          >
          </svg-icon>
          <span
            class="subspecializations"
            *ngFor="
              let childSpecialization of specialization.subSpecializations;
              let last = last
            "
          >
            {{
              last
                ? lastContainer
                  ? childSpecialization.name
                  : childSpecialization.name + ';'
                : childSpecialization.name + ','
            }}
          </span>
        </span>
      </div>
    </div>
    <div class="industries">
      <div
        class="work-experience-details-industry"
        *ngIf="workExperience.groupedIndustries?.length"
      >
        <span class="industry-label"
          >{{ 'label.IndustryField' | translate }}:
        </span>
        <span
          class="industries-main-container"
          *ngFor="
            let industry of workExperience.groupedIndustries;
            let lastContainer = last
          "
        >
          <span class="industries-main">{{ industry.head }}</span>
          <svg-icon
            class="categories__icon"
            src="/assets/icons/chevron-right-blue.svg"
          >
          </svg-icon>
          <span
            class="subindustries"
            *ngFor="
              let childIndustry of industry.subindustries;
              let last = last
            "
          >
            {{
              last
                ? lastContainer
                  ? childIndustry
                  : childIndustry + ';'
                : childIndustry + ','
            }}
          </span>
        </span>
      </div>
    </div>

        <div
      *ngIf="workExperience.fileName != null"
      class="attachment"
      [ngClass]="{ 'attachment--filled': workExperience.fileName }"
    >
      <app-advanced-button
        (click)="downloadAttachment(workExperience.experienceId)"
        [iconType]="iconButtonType.attachment"
        [text]="'label.Attachment' | translate"
        [type]="'blue'"
        class="add-button"
      ></app-advanced-button>
    </div>
  </div>
  <div class="work-experience__right">
    <div class="duration">
      <span *ngIf="workExperience.workExperienceDuration.year !== 0"
        >
        {{
          'label.Year'
            | translate: { count: workExperience.workExperienceDuration.year }
        }}
      </span>
      <span *ngIf="workExperience.workExperienceDuration.month !== 0"
        >
        {{
          'label.Month'
            | translate: { count: workExperience.workExperienceDuration.month }
        }}</span
      >
    </div>

    <div class="buttons">
      <app-icon-button
        *ngIf="userType === type.Jobseeker || userType === type.Internal"
        (click)="onEdit(workExperience)"
        [iconButtonType]="iconButtonType.editNew"
        class="buttons__edit"
      ></app-icon-button>
      <app-icon-button
        *ngIf="userType === type.Jobseeker || userType === type.Internal"
        (click)="onDelete(workExperience.experienceId, workExperience.objectId)"
        [iconButtonType]="iconButtonType.deleteRed"
        class="buttons__delete"
      ></app-icon-button>
    </div>
  </div>
</div>
